import { render, staticRenderFns } from "./paramet03.vue?vue&type=template&id=67ad2a26&scoped=true&"
import script from "./paramet03.vue?vue&type=script&lang=js&"
export * from "./paramet03.vue?vue&type=script&lang=js&"
import style0 from "./paramet03.vue?vue&type=style&index=0&id=67ad2a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad2a26",
  null
  
)

export default component.exports